(function(){
'use strict';
window.__osReady=true;
try{
var ROOT=document,
SHOP='https://ostove.com',
CDN='https://cdn.shopify.com/s/files/1/0552/4566/8418/files/',
NL=location.pathname==='/nl'||location.pathname.indexOf('/nl/')===0,
EN=location.pathname==='/en'||location.pathname.indexOf('/en/')===0,
QUIET=matchMedia('(prefers-reduced-motion: reduce)').matches,
D=window.__OSDATA||{};
function tr(de,nl,en){return NL?nl:(EN?(en||de):de);}
function localePath(){return NL?'/nl':(EN?'/en':'');}
function u(f,w){
var base=(f.indexOf('/')>-1||f.indexOf('http')===0)?f:CDN+f;
if(base.indexOf('http')!==0)base=CDN+f;
return base+(base.indexOf('?')>-1?'&':'?')+'width='+(w||800);}
function buy(id){return SHOP+localePath()+'/cart/add?id='+id+'&quantity=1&return_to='+localePath()+'/cart';}
function ss(f,ws){
var out=[];
for(var i=0;i<ws.length;i++)out.push(u(f,ws[i])+' '+ws[i]+'w');
return out.join(', ');}
var W_GAL=[360,540,760],W_MAS=[240,340,480],
S_GAL='(min-width:1000px) 46vw,(min-width:700px) 68vw, 92vw',
S_MAS='(min-width:1100px) 23vw,(min-width:820px) 31vw, 46vw';
function q(s,c){return [].slice.call((c||ROOT).querySelectorAll(s));}
var lazyLeft=[];
function load(im){
if(im.__done)return;im.__done=true;
var k=lazyLeft.indexOf(im);if(k>-1)lazyLeft.splice(k,1);
if(lio)lio.unobserve(im);
var s=im.getAttribute('data-src');if(!s){im.classList.add('ld');return;}
if(im.getAttribute('srcset')===null&&im.getAttribute('data-srcset'))
im.setAttribute('srcset',im.getAttribute('data-srcset'));
im.removeAttribute('loading');
im.addEventListener('load',function(){im.classList.add('ld');},{once:true});
im.addEventListener('error',function(){im.classList.add('ld');},{once:true});
im.src=s;
if(im.complete&&im.naturalWidth>0)im.classList.add('ld');}
var lio=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
es.forEach(function(e){if(e.isIntersecting)load(e.target);});},{rootMargin:'250px 0px 350px 0px'}):null;
function scanLazy(scope){
q('img[data-src]',scope).forEach(function(im){
if(im.__done||im.__seen)return;
im.__seen=true;lazyLeft.push(im);
if(lio)lio.observe(im);else load(im);});}
scanLazy();
function unlazy(){
q('img[src]').forEach(function(im){
if(im.dataset.keeplazy==='1')return;
if(im.hasAttribute('loading'))im.removeAttribute('loading');
var s=im.getAttribute('src');
if(s&&im.complete&&im.naturalWidth===0){
im.removeAttribute('src');im.setAttribute('src',s);}
if(!im.classList.contains('ld')){
if(im.complete&&im.naturalWidth>0)im.classList.add('ld');
else im.addEventListener('load',function(){im.classList.add('ld');},{once:true});}});}
unlazy();
addEventListener('load',unlazy);
var un=0,unIv=setInterval(function(){unlazy();if(++un>6)clearInterval(unIv);},500);
function startHomeFilm(){
if(QUIET)return;
var con=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
if(con&&(con.saveData||/(^|-)2g$/.test(con.effectiveType||'')))return;
q('video.home-video').forEach(function(v){
if(!v.getClientRects().length)return;
var film=v.closest?v.closest('.home-film'):v.parentNode;
v.addEventListener('playing',function(){
if(film)film.classList.add('is-playing');},{once:true});
try{v.load();}catch(e){}
var p=v.play();
if(p&&p.catch)p.catch(function(){});
setTimeout(function(){
if(!v.paused)return;
try{v.load();}catch(e){}
var retry=v.play();
if(retry&&retry.catch)retry.catch(function(){});},1400);});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(startHomeFilm,2000);},{once:true});
else setTimeout(startHomeFilm,2000);
q('video[data-os-inview]').forEach(function(v){
if(QUIET)return;
var seen=false,manual=false,fullscreen=false;
function start(){
if(!seen){try{v.load();}catch(e){}seen=true;}
var p=v.play();if(p&&p.catch)p.catch(function(){});}
function takeControl(){manual=true;}
['pointerdown','touchstart','keydown'].forEach(function(evt){
v.addEventListener(evt,takeControl,{passive:true});});
v.addEventListener('volumechange',function(){if(!v.muted)manual=true;});
v.addEventListener('webkitbeginfullscreen',function(){fullscreen=true;manual=true;});
v.addEventListener('webkitendfullscreen',function(){fullscreen=false;});
document.addEventListener('fullscreenchange',function(){
fullscreen=document.fullscreenElement===v||(v.contains&&v.contains(document.fullscreenElement));
if(fullscreen)manual=true;});
if('IntersectionObserver' in window){
new IntersectionObserver(function(es){es.forEach(function(e){
if(e.intersectionRatio>=.45){if(!manual)start();}
else if(!manual&&!fullscreen&&!v.paused)v.pause();});},{threshold:[0,.45,.8]}).observe(v);}else v.addEventListener('click',start,{once:true});});
function nachziehen(){
if(!lazyLeft.length)return;
for(var k=lazyLeft.length-1;k>=0;k--){
var r=lazyLeft[k].getBoundingClientRect();
if(r.width===0&&r.height===0)continue;
if(r.top<innerHeight+400&&r.bottom>-400&&r.right>-50&&r.left<innerWidth+50)
load(lazyLeft[k]);}}
var nz=0,nzIv=setInterval(function(){
nachziehen();if(++nz>8||!lazyLeft.length)clearInterval(nzIv);},700);
var pending=q('.rv');
function reveal(el){
el.classList.add('in');
el.style.opacity='1';el.style.transform='none';
var k=pending.indexOf(el);if(k>-1)pending.splice(k,1);
if(io)io.unobserve(el);}
var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
es.forEach(function(e){if(e.isIntersecting)reveal(e.target);});},{rootMargin:'0px 0px -5% 0px',threshold:0.01}):null;
if(io&&!QUIET)pending.slice().forEach(function(el){io.observe(el);});
else pending.slice().forEach(reveal);
var sweepBusy=false;
function sweep(){
if(sweepBusy||!pending.length)return;
sweepBusy=true;
setTimeout(function(){
for(var k=pending.length-1;k>=0;k--){
if(pending[k].getBoundingClientRect().top<innerHeight*0.96)reveal(pending[k]);}
sweepBusy=false;},150);}
var beats=0,beat=setInterval(function(){
if(!pending.length||++beats>40){clearInterval(beat);return;}
for(var k=pending.length-1;k>=0;k--){
var r=pending[k].getBoundingClientRect();
if(r.width===0&&r.height===0)continue;
if(r.top<innerHeight*0.96)reveal(pending[k]);}},500);
var prog=ROOT.getElementById('os-prog'),ticking=false;
var bar=ROOT.getElementById('os-buybar');
var barAnchor=bar?ROOT.getElementById(bar.dataset.after||''):null;
function onScroll(){
if(ticking)return;ticking=true;
requestAnimationFrame(function(){
if(prog){
var h=document.documentElement.scrollHeight - innerHeight;
prog.style.transform='scaleX('+(h>0?Math.min(1,(window.pageYOffset||0)/h):0)+')';}
if(bar&&barAnchor)
bar.classList.toggle('up',barAnchor.getBoundingClientRect().top<innerHeight * 0.35);
ticking=false;sweep();nachziehen();});}
addEventListener('scroll',onScroll,{passive:true});
addEventListener('resize',sweep,{passive:true});
onScroll();
var track=ROOT.getElementById('os-track');
if(track&&!QUIET)track.innerHTML+=track.innerHTML;
q('.card-sw').forEach(function(sw){
function preview(){
var card=sw.closest('.mcard'),im=card&&card.querySelector('.mcard-img');
if(!im||!sw.dataset.cardImg)return;
var overview=card.querySelector('.card-overview');
if(overview)overview.hidden=true;
im.hidden=false;
var lk=lazyLeft.indexOf(im);if(lk>-1)lazyLeft.splice(lk,1);
if(lio)lio.unobserve(im);im.__done=true;
im.removeAttribute('srcset');im.removeAttribute('data-srcset');
im.removeAttribute('data-src');im.removeAttribute('loading');
im.src=sw.dataset.cardImg;im.classList.add('ld');
var buyBtn=card.querySelector('.js-buy[data-buy-model]');
if(buyBtn&&sw.dataset.cardVariant){
buyBtn.dataset.buyVariant=sw.dataset.cardVariant;
buyBtn.setAttribute('href',buy(sw.dataset.cardVariant));}
q('.card-sw',card).forEach(function(x){x.setAttribute('aria-pressed',x===sw?'true':'false');});}
sw.addEventListener('click',preview);
sw.addEventListener('mouseenter',preview);});
var lb=ROOT.getElementById('os-lb'),lbImg=lb&&lb.querySelector('img'),set=[],idx=0;
function lbOpen(list,i){if(!lb)return;set=list;idx=i;lbImg.src=set[idx];lb.classList.add('open');}
function lbMove(d){idx=(idx+d+set.length)% set.length;lbImg.src=set[idx];}
if(lb){
lb.querySelector('.x').onclick=function(){lb.classList.remove('open');};
lb.querySelector('.p').onclick=function(){lbMove(-1);};
lb.querySelector('.n').onclick=function(){lbMove(1);};
lb.addEventListener('click',function(e){if(e.target===lb)lb.classList.remove('open');});
addEventListener('keydown',function(e){
if(!lb.classList.contains('open'))return;
if(e.key==='Escape')lb.classList.remove('open');
if(e.key==='ArrowLeft')lbMove(-1);
if(e.key==='ArrowRight')lbMove(1);});}
q('.gal[data-gal]').forEach(function(gal){
var conf=D.gal&&D.gal[gal.dataset.gal];
if(!conf)return;
var rail=gal.querySelector('.rail'),
dots=gal.querySelector('.dots'),
sw=gal.querySelector('.swatches'),
vl=gal.querySelector('.vlabel'),
btn=gal.dataset.buy?ROOT.getElementById(gal.dataset.buy):null,
v=0;
function cur(){return conf.variants[v];}
function build(imgs){
imgs=imgs||cur().imgs;
rail.innerHTML='';
imgs.forEach(function(o,i){
var fig=document.createElement('figure');
if(o.c)fig.className='contain';
var im=document.createElement('img');
im.setAttribute('data-src',u(o.f,W_GAL[0]));
im.setAttribute('data-srcset',ss(o.f,W_GAL));
im.setAttribute('sizes',S_GAL);
im.alt=EN?(conf.name+' — image '+(i+1)):
(NL?(conf.name+' — afbeelding '+(i+1)):(o.a||(conf.name+' — Bild '+(i+1))));
im.decoding='async';
fig.appendChild(im);
if(o.t){var fc=document.createElement('figcaption');fc.textContent=o.t;fig.appendChild(fc);}
fig.addEventListener('click',function(){
lbOpen(imgs.map(function(x){return u(x.f,1200);}),i);});
fig.style.cursor='zoom-in';
rail.appendChild(fig);});
dots.innerHTML='';
imgs.forEach(function(_,i){
var b=document.createElement('button');
b.type='button';b.setAttribute('aria-label',tr('Bild ','Afbeelding ','Image ')+(i+1));
b.setAttribute('aria-current',i===0?'true':'false');
b.addEventListener('click',function(){go(i);});
dots.appendChild(b);});
scanLazy(rail);
setTimeout(nachziehen,900);
rail.scrollLeft=0;}
function go(i){
var f=rail.children[i];if(!f)return;
rail.scrollTo({left:f.offsetLeft - rail.offsetLeft,behavior:QUIET?'auto':'smooth'});}
var st=false;
rail.addEventListener('scroll',function(){
if(st)return;st=true;
requestAnimationFrame(function(){
st=false;
var c=rail.scrollLeft+rail.clientWidth/2,best=0,bd=1e9;
[].forEach.call(rail.children,function(f,i){
var d=Math.abs(f.offsetLeft - rail.offsetLeft+f.offsetWidth/2 - c);
if(d<bd){bd=d;best=i;}});
[].forEach.call(dots.children,function(d,i){
d.setAttribute('aria-current',i===best?'true':'false');});});},{passive:true});
var pv=gal.querySelector('.prev'),nx=gal.querySelector('.next');
function step(d){
var c=rail.scrollLeft+rail.clientWidth/2,best=0,bd=1e9;
[].forEach.call(rail.children,function(f,i){
var dd=Math.abs(f.offsetLeft - rail.offsetLeft+f.offsetWidth/2 - c);
if(dd<bd){bd=dd;best=i;}});
go(Math.max(0,Math.min(rail.children.length-1,best+d)));}
if(pv)pv.addEventListener('click',function(){step(-1);});
if(nx)nx.addEventListener('click',function(){step(1);});
function setVariant(k){
v=k;
if(vl)vl.textContent=tr('Farbe: ','Kleur: ','Colour: ')+cur().label;
q('.js-buy[data-buy-model="'+gal.dataset.gal+'"]').forEach(function(a){
a.setAttribute('href',buy(cur().id));
a.dataset.buyVariant=cur().id;});
if(btn){btn.setAttribute('href',buy(cur().id));btn.dataset.buyVariant=cur().id;}
var bb=ROOT.getElementById('os-bbBuy');
if(bb&&gal.dataset.main==='1'){
bb.setAttribute('href',buy(cur().id));bb.dataset.buyVariant=cur().id;}
if(sw)[].forEach.call(sw.children,function(s,j){
s.setAttribute('aria-pressed',j===k?'true':'false');});
build(cur().imgs);}
if(sw){
if(conf.variants.length>1){
conf.variants.forEach(function(vr,k){
var b=document.createElement('button');
b.type='button';b.className='sw';b.style.background=vr.color;
b.title=vr.label;b.setAttribute('aria-label',vr.label);
b.setAttribute('aria-pressed','false');
b.addEventListener('click',function(){setVariant(k);});
sw.appendChild(b);});}else{sw.remove();if(vl)vl.remove();}}
setVariant(0);});
var mas=ROOT.getElementById('os-masonry');
if(mas&&D.mom){
var big=D.mom.map(function(m){return u(m[0],1200);});
var momentButtons=[];
D.mom.forEach(function(m,i){
var b=document.createElement('button');
b.type='button';b.setAttribute('aria-label',tr('Bild ','Afbeelding ','Image ')+(i+1)+tr(' gross ansehen',' groot bekijken',' enlarge'));
b.dataset.momentIndex=i;
b.dataset.momentTags=(m[3]||[]).join(' ');
var im=document.createElement('img');
im.width=m[1];im.height=m[2];
im.decoding='async';im.setAttribute('fetchpriority','low');
im.setAttribute('data-src',u(m[0],W_MAS[0]));
im.setAttribute('data-srcset',ss(m[0],W_MAS));
im.setAttribute('sizes',S_MAS);
im.alt=tr('OSTOVE Impression ','OSTOVE impressie ','OSTOVE impression ')+(i+1);
b.appendChild(im);
b.addEventListener('click',function(){
var visible=momentButtons.filter(function(x){return!x.hidden;});
var urls=visible.map(function(x){return big[Number(x.dataset.momentIndex)];});
lbOpen(urls,visible.indexOf(b));});
momentButtons.push(b);
mas.appendChild(b);});
q('.moment-filter').forEach(function(filter){
filter.addEventListener('click',function(){
var value=filter.dataset.momentFilter||'all';
q('.moment-filter').forEach(function(x){
x.setAttribute('aria-pressed',x===filter?'true':'false');});
momentButtons.forEach(function(card){
var tags=(card.dataset.momentTags||'').split(' ');
card.hidden=value!=='all'&&tags.indexOf(value)===-1;});});});
scanLazy(mas);}
var steps=q('#os-steps .step');
if(io&&steps.length){
var sio=new IntersectionObserver(function(es){
es.forEach(function(e){
if(!e.isIntersecting)return;
var i=steps.indexOf(e.target);
steps.forEach(function(s,k){s.classList.toggle('on',k===i);});});},{rootMargin:'-42% 0px -42% 0px'});
steps.forEach(function(s){sio.observe(s);});}
q('.facade').forEach(function(f){
f.addEventListener('click',function(){
var id=f.dataset.yt,fr=document.createElement('iframe');
fr.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';
fr.title=f.getAttribute('aria-label')||'Video';
fr.allow='accelerometer; autoplay; encrypted-media; picture-in-picture';
fr.allowFullscreen=true;
f.replaceWith(fr);},{once:true});});
if(bar&&!barAnchor)bar.classList.add('up');
var buyModal=ROOT.getElementById('os-buyModal');
if(buyModal&&D.models){
var buyState={key:null,variant:null},lastBuyFocus=null;
var buyPhoto=ROOT.getElementById('os-buyPhoto'),buyOverview=ROOT.getElementById('buyOverview'),
buyName=ROOT.getElementById('os-buyName'),buyColorHelp=ROOT.getElementById('buyColorHelp'),
buyPrice=ROOT.getElementById('os-buyPrice'),buyColors=ROOT.getElementById('os-buyColors'),
buyAccessories=ROOT.getElementById('os-buyAccessories'),buyTotal=ROOT.getElementById('os-buyTotal'),
buySubmit=ROOT.getElementById('os-buySubmit'),buyStatus=ROOT.getElementById('os-buyStatus'),
buyNoExtras=ROOT.getElementById('buyNoExtras');
function money(n){
try{return new Intl.NumberFormat(NL?'nl-NL':(EN?'en-AT':'de-AT'),{style:'currency',currency:'EUR'}).format(n);}
catch(e){return n.toFixed(2).replace('.',',')+' €';}}
function selectedExtras(){
return q('input[type="checkbox"]:checked',buyAccessories).map(function(x){return x.__acc;});}
function updateBuyTotal(){
var m=D.models[buyState.key],total=m?m.price_num:0;
var extras=selectedExtras();
extras.forEach(function(a){total+=a.price_num;});
buyTotal.textContent=money(total);
if(buyNoExtras)buyNoExtras.setAttribute('aria-pressed',extras.length?'false':'true');}
function chooseBuyVariant(i){
var m=D.models[buyState.key],v=m.variants[i];if(!v)return;
buyState.variant=v;
if(buyOverview)buyOverview.hidden=true;
buyPhoto.hidden=false;
buyPhoto.src=u(v.img,580);buyPhoto.alt=(m.product_name||m.name)+' – '+v.label;
q('button',buyColors).forEach(function(b,k){b.setAttribute('aria-pressed',k===i?'true':'false');});
if(buyColorHelp)buyColorHelp.textContent=tr('Gewählt: ','Gekozen: ','Selected: ')+v.label;
buySubmit.disabled=false;buyStatus.textContent='';}
function openBuy(key,preferred){
var m=D.models[key];if(!m)return;
buyState.key=key;buyState.variant=null;lastBuyFocus=ROOT.activeElement;
buyName.textContent=m.product_name||m.name;buyPrice.textContent=m.price;
buyPhoto.hidden=true;buyPhoto.removeAttribute('src');
buyOverview.hidden=false;buyOverview.innerHTML='';
(m.overview_imgs||[]).forEach(function(f){
var im=ROOT.createElement('img');im.src=u(f,360);im.alt=(m.product_name||m.name)+tr(' Farbübersicht',' kleurenoverzicht',' colour overview');
im.width=280;im.height=280;buyOverview.appendChild(im);});
buyColors.innerHTML='';
m.variants.forEach(function(v,i){
var b=ROOT.createElement('button');b.type='button';b.className='buy-color';
b.style.setProperty('--sw',v.color);b.innerHTML='<i></i><span>'+v.label+'</span>';
b.setAttribute('aria-pressed','false');b.addEventListener('click',function(){chooseBuyVariant(i);});
buyColors.appendChild(b);});
buyAccessories.innerHTML='';
(D.accessories||[]).forEach(function(a){
if(a.models&&a.models.length&&a.models.indexOf(key)===-1)return;
var label=ROOT.createElement('label'),cb=ROOT.createElement('input');
cb.type='checkbox';cb.__acc=a;cb.addEventListener('change',function(){
updateBuyTotal();});
label.appendChild(cb);
var im=ROOT.createElement('img');im.src=u(a.img,180);im.alt='';im.width=90;im.height=90;
label.appendChild(im);
var tx=ROOT.createElement('span');tx.innerHTML='<b>'+a.name+'</b><small>'+a.pitch+'</small><strong>+ '+a.price+'</strong>';
label.appendChild(tx);buyAccessories.appendChild(label);});
if(buyNoExtras)buyNoExtras.setAttribute('aria-pressed','true');
updateBuyTotal();
var preferredIndex=-1;
if(preferred){
m.variants.some(function(v,i){if(String(v.id)===String(preferred)){preferredIndex=i;return true;}return false;});}
if(preferredIndex>-1){
chooseBuyVariant(preferredIndex);
if(buyColorHelp)buyColorHelp.hidden=false;}
else if(m.variants.length===1){chooseBuyVariant(0);if(buyColorHelp)buyColorHelp.hidden=true;}
else{
buySubmit.disabled=true;buyStatus.textContent=tr('Bitte zuerst eine Farbe wählen.','Kies eerst een kleur.','Please choose a colour first.');
if(buyColorHelp){buyColorHelp.hidden=false;buyColorHelp.textContent=tr('Bitte zuerst eine Farbe wählen.','Kies eerst een kleur.','Please choose a colour first.');}}
buyModal.hidden=false;ROOT.documentElement.classList.add('buy-open');
ROOT.documentElement.style.overflow='hidden';
setTimeout(function(){var c=ROOT.getElementById('os-buyModalClose');if(c)c.focus();},20);}
function closeBuy(){
buyModal.hidden=true;ROOT.documentElement.classList.remove('buy-open');
ROOT.documentElement.style.overflow='';
if(lastBuyFocus&&lastBuyFocus.focus)lastBuyFocus.focus();}
ROOT.addEventListener('click',function(e){
var b=e.target.closest('.js-buy[data-buy-model]');
if(b){
e.preventDefault();e.stopPropagation();
if(e.stopImmediatePropagation)e.stopImmediatePropagation();
openBuy(b.dataset.buyModel,b.dataset.buyVariant);return;}
if(e.target.closest('[data-buy-close]'))closeBuy();},true);
addEventListener('keydown',function(e){if(e.key==='Escape'&&!buyModal.hidden)closeBuy();});
if(buyNoExtras)buyNoExtras.addEventListener('click',function(){
q('input[type="checkbox"]',buyAccessories).forEach(function(cb){cb.checked=false;});
updateBuyTotal();});
buySubmit.addEventListener('click',function(){
if(!buyState.variant){buyStatus.textContent=tr('Bitte zuerst eine Farbe wählen.','Kies eerst een kleur.','Please choose a colour first.');return;}
var items=[{id:Number(buyState.variant.id),quantity:1}];
selectedExtras().forEach(function(a){items.push({id:Number(a.id),quantity:1});});
buySubmit.disabled=true;buyStatus.textContent=tr('Auswahl wird hinzugefügt …','Selectie wordt toegevoegd …','Adding your selection …');
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({items:items})}).then(function(r){if(!r.ok)throw new Error('cart');return r.json();}).then(function(){location.href=localePath()+'/cart';}).catch(function(){buySubmit.disabled=false;buyStatus.textContent=tr('Das hat nicht geklappt. Bitte noch einmal versuchen.','Dat is niet gelukt. Probeer het opnieuw.','That did not work. Please try again.');});});}
var compareLab=ROOT.querySelector('[data-compare-lab]');
if(compareLab){
var compareOrder=['air','original','pro'],compareModel='air',compareFeature='';
var compareSlider=compareLab.querySelector('.compare-slider input');
function setCompare(model,feature){
if(compareOrder.indexOf(model)>-1)compareModel=model;
if(typeof feature==='string')compareFeature=feature;
q('[data-compare-model]',compareLab).forEach(function(b){
var on=b.dataset.compareModel===compareModel;
b.classList.toggle('on',on);b.setAttribute('aria-pressed',on?'true':'false');});
q('[data-compare-photo]',compareLab).forEach(function(im){
var on=im.dataset.comparePhoto===compareModel;
im.hidden=!on;im.classList.toggle('on',on);if(on)load(im);});
q('[data-compare-feature]',compareLab).forEach(function(b){
if(b.hasAttribute('data-compare-model'))return;
var on=b.dataset.compareFeature===compareFeature;
b.classList.toggle('on',on);b.setAttribute('aria-pressed',on?'true':'false');});
q('[data-compare-answer]',compareLab).forEach(function(p){
var parts=p.dataset.compareAnswer.split(':');
p.hidden=parts[0]!==compareModel||(!!compareFeature&&parts[1]!==compareFeature);});
var answers=compareLab.querySelector('.compare-answers');
if(answers)answers.classList.toggle('is-filtered',!!compareFeature);
var status=compareLab.querySelector('[data-compare-status]');
if(status)status.textContent=compareFeature
?tr('Gefiltert nach Kategorie · erneut tippen für alle Eigenschaften',
'Gefilterd op categorie · tik opnieuw voor alle eigenschappen',
'Filtered by category · tap again to show all features')
:tr('Alle Eigenschaften · Kategorie wählen zum Filtern',
'Alle eigenschappen · kies een categorie om te filteren',
'All features · choose a category to filter');
if(compareSlider)compareSlider.value=String(compareOrder.indexOf(compareModel));
var cta=compareLab.querySelector('.compare-cta .js-buy');
if(cta&&D.models&&D.models[compareModel]){
var m=D.models[compareModel];cta.dataset.buyModel=compareModel;cta.href=m.url;
cta.textContent=m.variants&&m.variants.length===1
?tr('In den Warenkorb','In winkelwagen','Add to cart')
:tr('Farbe wählen','Kleur kiezen','Choose colour');}}
compareLab.addEventListener('click',function(e){
var mb=e.target.closest('[data-compare-model]');
if(mb){setCompare(mb.dataset.compareModel);return;}
var fb=e.target.closest('[data-compare-feature]');
if(fb)setCompare(compareModel,compareFeature===fb.dataset.compareFeature?'':fb.dataset.compareFeature);});
if(compareSlider)compareSlider.addEventListener('input',function(){
setCompare(compareOrder[Number(this.value)]||'air');});
setCompare('air','');}
var finder=ROOT.getElementById('os-finder');
if(finder&&D.models){
var picks={};
q('.opts',finder).forEach(function(g){
g.addEventListener('click',function(e){
var b=e.target.closest('.opt');if(!b)return;
q('.opt',g).forEach(function(o){o.setAttribute('aria-pressed','false');});
b.setAttribute('aria-pressed','true');
picks[g.dataset.k]=b.dataset.v;
evaluate();});});
function evaluate(){
if(Object.keys(picks).length<3)return;
var best;
if(picks.brenn==='kohle'){
best='pro';}else{
var s={air:0,original:0,pro:0};
if(picks.wo==='unterwegs'){s.air+=3;}
if(picks.wo==='garten'){s.original+=2;s.pro+=1;}
if(picks.wo==='notfall'){s.air+=1;s.original+=1;s.pro+=1;}
if(picks.brenn==='holz'){s.original+=2;s.air+=1;}
if(picks.brenn==='egal'){s.pro+=1;}
if(picks.prioritaet==='mobil'){s.air+=5;}
if(picks.prioritaet==='speicher'){s.original+=5;}
if(picks.prioritaet==='regelbar'){s.pro+=6;}
best='original';var bv=s.original;
if(s.air>bv){best='air';bv=s.air;}
if(s.pro>bv){best='pro';bv=s.pro;}}
var m=D.models[best],box=ROOT.getElementById('os-result');
ROOT.getElementById('os-rTitle').textContent=m.name;
ROOT.getElementById('os-rWhy').textContent=m.why;
ROOT.getElementById('os-rTradeoff').textContent=m.tradeoff;
var rb=ROOT.getElementById('os-rBuy');
rb.setAttribute('href',m.url);rb.dataset.buyModel=best;
rb.textContent=m.variants&&m.variants.length===1?tr('In den Warenkorb','In winkelwagen','Add to cart'):tr('Farbe wählen','Kleur kiezen','Choose colour');
var lk=ROOT.getElementById('os-rLink');
lk.setAttribute('href',m.url);lk.textContent=tr('Alles zum ','Alles over ','All about ')+m.short;
box.hidden=false;
box.classList.add('in');box.style.opacity='1';box.style.transform='none';}}}catch(err){
if(window.console&&console.warn)console.warn('OSTOVE:',err);
document.documentElement.className='no-js';
try{
[].forEach.call(document.querySelectorAll('.rv'),function(e){
e.style.opacity='1';e.style.transform='none';});
[].forEach.call(document.querySelectorAll('img[data-src]'),function(im){
im.removeAttribute('loading');im.src=im.getAttribute('data-src');im.classList.add('ld');});
[].forEach.call(document.querySelectorAll('img'),function(im){im.classList.add('ld');});}catch(e2){}}})();